export const ASSOCIATION_LIST = 'ASSOCIATION_LIST'
export const ORGANIZATION_DATA = 'ORGANIZATION_DATA'
